import React from 'react'
import { ProductScreenVisual } from './ProductScreenVisual'

type LandingHeroCopy = {
  nav: string[]
  getStarted: string
  heroEyebrow: string
  heroTitle: string
  heroCopy: string
  heroProof: string[]
  heroPrimaryCta?: string
  heroSecondaryCta?: string
  heroSecondaryHref?: string
}

type LandingHeroProps = {
  copy: LandingHeroCopy
  appHref: string
}

export const LandingHero: React.FC<LandingHeroProps> = ({ copy, appHref }) => {
  return (
    <section className="landing-hero">
      <div className="container landing-hero__grid">
        <div className="landing-hero__copy">
          <p className="landing-eyebrow">{copy.heroEyebrow}</p>
          <h1>{copy.heroTitle}</h1>
          <p className="landing-lede">{copy.heroCopy}</p>
          <div className="landing-hero__actions">
            <a className="btn btn-primary" href={appHref}>{copy.heroPrimaryCta ?? copy.getStarted}</a>
            <a className="btn btn-secondary" href={copy.heroSecondaryHref ?? '#screens'}>{copy.heroSecondaryCta ?? copy.nav[3]}</a>
          </div>
          <div className="landing-proof">
            {copy.heroProof.map((item) => <span key={item}>{item}</span>)}
          </div>
        </div>
        <div className="landing-dashboard-preview landing-dashboard-preview--media" aria-label="NexusWorkforce360 product preview">
          <ProductScreenVisual variant="network-dashboard" className="landing-product-screen landing-product-screen--hero" />
        </div>
      </div>
    </section>
  )
}
